import { useEffect, useState } from 'react'
import { api } from '../lib/api'
import { navigeer } from '../lib/router'
import { openTaak } from '../lib/staat'
import { Foutvlak, Laden } from './ui'

/* ===========================================================================
 *  /taak/:id -- een link naar één taak
 *
 *  Uit een seintje, uit de knop "Openen in Projects" in Werk, uit een
 *  gekopieerde link in de chat, of een taaknummer in een omschrijving
 *  (/taak/WEB-12). Wat hier gebeurt: de taak opzoeken, naar het bord van zijn
 *  project gaan, en hem daar als lade openen. Dan sta je na het sluiten op
 *  een plek die ergens over gaat, en niet op een leeg scherm.
 * =========================================================================== */

export default function TaakRoute({ id }: { id: string }) {
  const [fout, setFout] = useState<string | null>(null)

  useEffect(() => {
    let weg = false
    ;(async () => {
      try {
        let taakId = id
        let projectId: string | null = null

        if (/^[A-Za-z][A-Za-z0-9]{1,9}-\d{1,6}$/.test(id)) {
          const { taken } = await api.zoeken(id.toUpperCase())
          const t = taken[0]
          if (!t) throw new Error(`Er is geen taak ${id.toUpperCase()}.`)
          taakId = t.id
          projectId = t.projectId
        } else {
          const { taak } = await api.taak(id)
          projectId = taak.projectId
        }
        if (weg) return
        navigeer(projectId ? `/p/${projectId}/bord` : '/mijn', true)
        openTaak(taakId)
      } catch (e) {
        if (!weg) setFout(e instanceof Error ? e.message : String(e))
      }
    })()
    return () => { weg = true }
  }, [id])

  if (fout) return <div className="pagina"><Foutvlak fout={fout} /></div>
  return <Laden tekst="De taak wordt opgezocht…" />
}
